import { reset } from './reset';

// ----------------------------------------------------------------------------

function target(element: HTMLElement, config: Record<string, any> = {}): Record<string, any> | undefined {
    let isRemove = false;
    const elTableBody = element.querySelector('tbody');

    if (!elTableBody) {
        return;
    }

    const listRow = Array.from(elTableBody.rows);

    for (let r = 0; r < listRow.length; r++) {
        const elRow = listRow[r];

        if (r != config.rowCount) {
            elRow.remove();
            isRemove = true;
        } else {
            const listCell = Array.from(elRow.cells);

            for (let c = 0; c < listCell.length; c++) {
                const elColumn = listCell[c];

                if (c != config.columnCount) {
                    elColumn.remove();
                    isRemove = true;
                }
            }
        }
    }

    const arr = reset.layouts(element)[0];

    if (!arr) {
        return {
            element: undefined,
            isRemove: isRemove,
        };
    }

    return {
        element: arr.element,
        isRemove: isRemove,
    };
}

// ----------------------------------------------------------------------------

export { target };
